/* eslint-disable camelcase */

import { useMemo, useState } from 'react';

import { useTranslation } from 'providers/GILT.provider';

import StylistButtonComponent from 'booking/components/common/StylistButton';

const SHOWN_STYLISTS = 9;

export const StylistList = ({ stylistList, selectedStylist, changeStylist, service }) => {
  const [showMore, setShowMore] = useState(false);

  const { t } = useTranslation();

  const activeStylists = useMemo(() => stylistList.filter((s) => s.status === 'active'), [stylistList]);

  const visibleStylists = useMemo(() => (showMore ? activeStylists : activeStylists.slice(0, SHOWN_STYLISTS)), [activeStylists, showMore]);

  return (
    <div className="stylist-list">
      <div className="list-container">
        {visibleStylists.map((stylist) => {
          if (!stylist.has_column) return null;
          const checked = selectedStylist?.id === stylist.id;

          return (
            <StylistButtonComponent
              key={stylist.user_name}
              name={stylist.user_name}
              service={service}
              changeStylist={() => changeStylist(stylist.user_name)}
              checked={checked}
              selectedStylist={selectedStylist}
              activeStylists={visibleStylists}
            />
          );
        })}
      </div>

      {!showMore && activeStylists.length > SHOWN_STYLISTS && (
        <div className="more-less-btn" onClick={() => setShowMore(true)} role="button" tabIndex="-3">
          <p>{t('scheduler.booking.moreButton')}</p>
        </div>
      )}
    </div>
  );
};
